import localforage from "localforage";

export const getStoreInstance = (
  storeName: string,
  dbName = "support-sync-local-store",
  description = "store description",
): LocalForage => {
  if (import.meta.server) {
    return {
      async getItem(key: string) {
        return key ? null : null;
      },
      async setItem(key: string, value: string | null) {
        return value;
      },
      async removeItem(key: string) {
        if (key) {
          return;
        }
      },
    } as unknown as LocalForage;
  }

  return localforage.createInstance({
    name: dbName,
    storeName,
    driver: [
      localforage.INDEXEDDB,
      localforage.WEBSQL,
      localforage.LOCALSTORAGE,
    ],
    description,
    size: 100 * 1024 * 1024,
  });
};
